// frontend/src/api/finance.js
import { apiClient } from './index';

const financeApi = {
  getStats: async () => {
    return await apiClient.get('/finance/stats');
  },

  getTransactions: async () => {
    return await apiClient.get('/finance/transactions');
  },

  /**
   * Delete multiple transactions
   * @param {Array} items - Array of objects { id, source }
   */
  deleteTransactions: async (items) => {
    return await apiClient.delete('/finance/transactions', { body: { items } });
  },
  
  /**
   * Fetch settlements from Flutterwave via backend
   * @param {number} page 
   * @param {number} size 
   */
  getSettlements: async (page = 1, size = 20) => {
      return await apiClient.get(`/finance/settlements?page=${page}&size=${size}`);
  },
  
  /**
   * NEW: Initiate a refund for a transaction
   * @param {string} transactionId - The Flutterwave transaction ID
   * @param {number} amount - The amount to refund (partial or full)
   * @param {string} reason - The reason for the refund
   */
  initiateRefund: async (transactionId, amount, reason) => {
      return await apiClient.post('/finance/refund', {
          transaction_id: transactionId,
          amount: amount,
          reason: reason
      });
  },

  /**
   * NEW: Fetch the Financial Audit Trail (Manual Credits)
   */
  getAuditTrail: async () => {
      return await apiClient.get('/finance/audit-trail');
  }
};

export { financeApi };